import { useRef, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getPatients } from '../services/patients';

export default function usePatients(actor, filters) {
    const [paginationModel, setPagination] = useState({ page: 0, pageSize: 10 });
    const tokens = useRef({ 0: null });
    const query = useQuery({
        queryKey: ['clinic-patients', actor.role?.uuid, actor.role?.account?.uuid, filters, paginationModel],
        queryFn: ({ signal }) => getPatients(actor, {
            ...filters, signal, pageSize: paginationModel.pageSize, token: tokens.current[paginationModel.page]
        }),
        enabled: actor.role?.name === 'CLINIC_ADMIN', retry: 1, placeholderData: keepPreviousData
    });
    const changePage = (next) => {
        if (next.pageSize !== paginationModel.pageSize) {
            tokens.current = { 0: null };
            setPagination({ page: 0, pageSize: next.pageSize });
            return;
        }
        if (query.isFetching || query.isError || query.isPlaceholderData) return;
        if (next.page === paginationModel.page + 1 && query.data?.nextToken) tokens.current[next.page] = query.data.nextToken;
        if (Object.prototype.hasOwnProperty.call(tokens.current, next.page)) setPagination(next);
    };
    return { ...query, paginationModel, changePage };
}
